// extracted by mini-css-extract-plugin
export default {"container":"mAZF70It--ItemFeatureDetails_container__BXIE9","title":"mAZF70It--ItemFeatureDetails_title__mbAWJ"};